import "./text-error.scss";

const TextError = ({children}) => (

    <div className = "cart-text-error">
        {children}
    </div>
);

export default TextError;